(function () {
  'use strict';

  var QUESTION_COUNT = 4;

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function selectedAnswers(section) {
    var answers = {};

    section.querySelectorAll('.wp-selector-option.is-selected').forEach(function (button) {
      var question = button.closest('[data-question]');
      if (!question) return;

      var key = question.getAttribute('data-question');
      answers[key] = {
        value: button.getAttribute('data-answer') || '',
        maxPrice: Number(button.getAttribute('data-max-price')) || 0
      };
    });

    return answers;
  }

  function answerValue(answers, key) {
    return answers[key] ? answers[key].value : '';
  }

  function addViolation(violations, key) {
    if (violations.indexOf(key) === -1) violations.push(key);
  }

  function evaluateModel(model, answers) {
    var score = 0;
    var violations = [];
    var matched = [];
    var activity = answerValue(answers, 'activity');
    var space = answerValue(answers, 'space');
    var budget = answers.budget || null;
    var handrail = answerValue(answers, 'handrail');
    var price = Number(model.priceNumeric) || 0;

    if (model.available === false) {
      addViolation(violations, 'availability');
    }

    if (model.scoringRules && Object.keys(model.scoringRules).length) {
      Object.keys(answers).forEach(function (key) {
        var value = answerValue(answers, key);
        if (value && Object.prototype.hasOwnProperty.call(model.scoringRules, value)) {
          score += Number(model.scoringRules[value]) || 0;
        }
      });

      return {
        model: model,
        score: score,
        violations: violations,
        matched: matched
      };
    }

    if (activity === 'daily_walk') {
      score += 24;
      matched.push('daily walking');
    } else if (activity === 'work') {
      if (model.supportsWork) {
        score += 48;
        matched.push('under-desk work');
      } else {
        addViolation(violations, 'activity');
      }
    } else if (activity === 'walk_jog') {
      if (model.supportsJog) {
        score += 48;
        matched.push('walking and jogging');
      } else {
        addViolation(violations, 'activity');
      }
    } else if (activity === 'run') {
      if (model.supportsRun) {
        score += 48 + Math.min(8, Math.max(0, Number(model.maxSpeed) - 12));
        matched.push('home running');
      } else {
        addViolation(violations, 'activity');
      }
    }

    if (space === 'tight_flat') {
      if (model.storage === 'flat_fold') {
        score += 32;
        matched.push('low-profile storage');
      } else {
        addViolation(violations, 'space');
      }
    } else if (space === 'fold_away') {
      if (model.storage !== 'dedicated') {
        score += model.storage === 'compact_fold' ? 28 : 22;
        matched.push('fold-away storage');
      } else {
        addViolation(violations, 'space');
      }
    } else if (space === 'upright') {
      if (model.storage === 'upright_fold') {
        score += 32;
        matched.push('upright storage');
      } else {
        addViolation(violations, 'space');
      }
    } else if (space === 'dedicated') {
      score += model.storage === 'dedicated' ? 14 : 10;
      matched.push('your available space');
    }

    if (budget) {
      if (budget.value === 'flexible' || !budget.maxPrice || !price) {
        score += 8;
        if (budget.value === 'flexible') matched.push('fit-first budget');
      } else if (price <= budget.maxPrice) {
        score += 24;
        score += Math.max(0, Math.round((1 - price / budget.maxPrice) * 6));
        matched.push('your budget');
      } else {
        addViolation(violations, 'budget');
        score -= Math.min(18, Math.round(((price - budget.maxPrice) / budget.maxPrice) * 20));
      }
    }

    if (handrail === 'require') {
      if (model.handrail) {
        score += 22;
        matched.push('essential handrail support');
      } else {
        addViolation(violations, 'handrail');
      }
    } else if (handrail === 'prefer') {
      if (model.handrail) {
        score += 16;
        matched.push('handrail preference');
      } else {
        score -= 2;
      }
    } else if (handrail === 'no') {
      if (!model.handrail) {
        score += 15;
        matched.push('a rail-free profile');
      } else {
        score += model.supportsWork ? 5 : 0;
      }
    } else if (handrail === 'unsure') {
      score += 4;
    }

    return {
      model: model,
      score: score,
      violations: violations,
      matched: matched
    };
  }

  function rankModels(models, answers, fallbackKey) {
    var hasAvailable = models.some(function (model) { return model.available !== false; });
    var violationWeight = {
      availability: 200,
      activity: 100,
      handrail: 80,
      space: 40,
      budget: 30
    };

    return models
      .map(function (model) { return evaluateModel(model, answers); })
      .filter(function (result) {
        return !hasAvailable || result.model.available !== false;
      })
      .sort(function (a, b) {
        var penaltyA = a.violations.reduce(function (total, key) {
          return total + (violationWeight[key] || 10);
        }, 0);
        var penaltyB = b.violations.reduce(function (total, key) {
          return total + (violationWeight[key] || 10);
        }, 0);
        if (penaltyA !== penaltyB) {
          return penaltyA - penaltyB;
        }
        if (a.score !== b.score) return b.score - a.score;

        var priceA = Number(a.model.priceNumeric) || Number.MAX_SAFE_INTEGER;
        var priceB = Number(b.model.priceNumeric) || Number.MAX_SAFE_INTEGER;
        if (priceA !== priceB) return priceA - priceB;

        if (a.model.key === fallbackKey) return -1;
        if (b.model.key === fallbackKey) return 1;
        return String(a.model.name || '').localeCompare(String(b.model.name || ''));
      });
  }

  function caveatFor(result) {
    var violations = result.violations || [];
    var messages = [];

    if (violations.indexOf('budget') !== -1) {
      messages.push('This is the closest functional match, but its live price is above the budget selected.');
    }
    if (violations.indexOf('activity') !== -1) {
      messages.push('No configured model meets the selected activity exactly; compare its speed before choosing.');
    }
    if (violations.indexOf('space') !== -1) {
      messages.push('Its storage format differs from the option selected.');
    }
    if (violations.indexOf('handrail') !== -1) {
      messages.push('It does not include the handrail support marked as essential.');
    }

    return messages.join(' ');
  }

  function reasonFor(result) {
    var base = String(result.model.reason || '').trim();
    var matched = result.matched.slice(0, 3);

    if (!matched.length) return base || 'The closest match from the models currently configured.';

    var fitText = matched.length === 1
      ? matched[0]
      : matched.slice(0, -1).join(', ') + ' and ' + matched[matched.length - 1];

    return (base ? base + ' ' : '') + 'It aligns with ' + fitText + '.';
  }

  function fitLabel(result, answeredCount) {
    if (!answeredCount) return 'Start here';
    var needsViolations = result.violations.filter(function (key) {
      return key !== 'availability';
    }).length;
    var matchedCount = Math.max(0, answeredCount - needsViolations);
    return matchedCount + ' of ' + answeredCount + ' needs matched';
  }

  function updateImage(image, media, model) {
    if (!image || !media) return;

    if (model.image) {
      image.loading = 'eager';
      image.setAttribute('fetchpriority', 'high');
      image.src = model.image;
      if (model.image2x) {
        image.setAttribute('srcset', model.image + ' 1x, ' + model.image2x + ' 2x');
      } else {
        image.removeAttribute('srcset');
      }
      image.alt = model.imageAlt || model.name || '';
      media.removeAttribute('hidden');
    } else {
      image.removeAttribute('src');
      image.removeAttribute('srcset');
      media.setAttribute('hidden', '');
    }
  }

  function updatePrimary(section, result, answeredCount, compareUrl) {
    var card = section.querySelector('[data-result-model]');
    if (!card || !result || !result.model) return;

    var model = result.model;
    var name = card.querySelector('[data-result-name]');
    var seriesName = card.querySelector('[data-result-series-name]');
    var eyebrow = card.querySelector('[data-result-eyebrow]');
    var fit = card.querySelector('[data-result-fit]');
    var why = card.querySelector('[data-result-why]');
    var caveat = card.querySelector('[data-result-caveat]');
    var price = card.querySelector('[data-result-price]');
    var image = card.querySelector('[data-result-image]');
    var media = card.querySelector('.wp-result-card__media');
    var primary = card.querySelector('[data-result-primary]');
    var secondary = card.querySelector('[data-result-secondary]');
    var specs = card.querySelectorAll('[data-result-spec]');

    card.setAttribute('data-result-model', model.key || '');
    if (name) name.textContent = model.name || 'Recommended model';
    if (seriesName) seriesName.textContent = model.seriesName || 'Recommended model';
    if (eyebrow) eyebrow.textContent = answeredCount ? (model.badge || 'Best match') : (model.badge || 'Popular starting point');
    if (fit) fit.textContent = fitLabel(result, answeredCount);
    if (why) why.textContent = reasonFor(result);

    var caveatText = caveatFor(result);
    if (caveat) {
      caveat.textContent = caveatText;
      if (caveatText) caveat.removeAttribute('hidden');
      else caveat.setAttribute('hidden', '');
    }

    if (price) {
      if (model.price) {
        price.textContent = model.price;
        price.removeAttribute('hidden');
      } else {
        price.textContent = '';
        price.setAttribute('hidden', '');
      }
    }

    updateImage(image, media, model);

    specs.forEach(function (item, index) {
      var value = model.specs && model.specs[index] ? model.specs[index] : '';
      item.textContent = value;
      item.hidden = !value;
    });

    if (primary) {
      primary.textContent = model.primaryCta || 'View ' + (model.name || 'model');
      primary.href = model.productUrl || model.seriesUrl || compareUrl || '#';
      primary.setAttribute('data-model-key', model.key || '');
    }

    if (secondary) {
      secondary.textContent = 'Compare models';
      secondary.href = compareUrl || model.seriesUrl || model.productUrl || '#';
      secondary.setAttribute('data-model-key', model.key || '');
    }

    var status = section.querySelector('[data-wp-status]');
    if (status && answeredCount) {
      status.textContent = 'Current recommendation: ' + (model.name || 'WalkingPad') + '. ' + fitLabel(result, answeredCount) + '.';
    }

    window.dispatchEvent(
      new CustomEvent('wp-series-selector:recommendation', {
        detail: {
          sectionId: section.getAttribute('data-section-id'),
          modelKey: model.key || '',
          modelName: model.name || '',
          seriesName: model.seriesName || '',
          answeredCount: answeredCount,
          violations: result.violations.slice()
        }
      })
    );
  }

  function alternativeNote(result, answeredCount) {
    if (!result.violations.length && answeredCount === QUESTION_COUNT) {
      return 'Also meets all four choices';
    }
    if (result.violations.indexOf('budget') !== -1) return 'Closest fit above budget';
    if (result.violations.indexOf('space') !== -1) return 'Different storage format';
    if (result.violations.indexOf('handrail') !== -1) return 'No essential handrail';
    if (result.violations.indexOf('activity') !== -1) return 'Different activity level';
    return result.model.badge || 'Another close fit';
  }

  function updateAlternatives(section, ranked, answeredCount) {
    var wrapper = section.querySelector('[data-result-alternatives]');
    var cards = toArray(section.querySelectorAll('[data-alternative]'));
    var alternatives = ranked.slice(1, 3);

    if (!wrapper || answeredCount === 0 || alternatives.length === 0) {
      if (wrapper) wrapper.setAttribute('hidden', '');
      return;
    }

    wrapper.removeAttribute('hidden');
    cards.forEach(function (card, index) {
      var result = alternatives[index];
      if (!result) {
        card.setAttribute('hidden', '');
        return;
      }

      var model = result.model;
      var name = card.querySelector('[data-alternative-name]');
      var note = card.querySelector('[data-alternative-note]');
      var link = card.querySelector('[data-alternative-link]');
      var thumb = card.querySelector('[data-alternative-thumb]');
      var image = card.querySelector('[data-alternative-image]');

      card.removeAttribute('hidden');
      card.setAttribute('data-model-key', model.key || '');
      if (name) name.textContent = model.name || 'WalkingPad';
      if (note) note.textContent = alternativeNote(result, answeredCount);

      if (link) {
        link.href = model.productUrl || model.seriesUrl || '#';
        link.setAttribute('data-model-key', model.key || '');
        link.setAttribute('aria-label', 'View ' + (model.name || 'alternative model'));
      }

      if (thumb && image) {
        if (model.image) {
          image.src = model.image;
          image.alt = model.imageAlt || model.name || '';
          thumb.removeAttribute('hidden');
        } else {
          image.removeAttribute('src');
          thumb.setAttribute('hidden', '');
        }
      }
    });
  }

  function setupWizard(section) {
    var mql = window.matchMedia('(max-width: 989px)');
    var track = section.querySelector('[data-wp-track]');
    var questions = toArray(section.querySelectorAll('.wp-selector-track .wp-selector-question'));
    var backButton = section.querySelector('[data-wp-back]');
    var progressText = section.querySelector('[data-wp-progress-text]');
    var progressFill = section.querySelector('[data-wp-progress-fill]');
    var total = questions.length;
    var step = 0;
    var showingResult = false;
    var advanceTimer = null;
    var supportsInert = typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;

    if (!track || total === 0) {
      return { onAnswered: function () {} };
    }

    function setInactiveSlides() {
      questions.forEach(function (question, index) {
        var inactive = showingResult || index !== step;
        if (supportsInert) question.inert = inactive;
        question.setAttribute('aria-hidden', inactive ? 'true' : 'false');
      });
    }

    function render() {
      if (progressText) {
        progressText.textContent = showingResult ? 'Your matches' : 'Question ' + (step + 1) + ' of ' + total;
      }
      if (progressFill) {
        progressFill.style.width = (showingResult ? 100 : ((step + 1) / total) * 100) + '%';
      }
      if (backButton) backButton.disabled = !showingResult && step === 0;
      track.style.transform = 'translateX(-' + step * 100 + '%)';
      setInactiveSlides();
    }

    function goToStep(index) {
      showingResult = false;
      section.classList.remove('is-result');
      step = Math.max(0, Math.min(total - 1, index));
      render();
    }

    function showResult() {
      showingResult = true;
      section.classList.add('is-result');
      render();
    }

    function enter() {
      section.classList.add('is-wizard');
      render();
    }

    function exit() {
      if (advanceTimer) clearTimeout(advanceTimer);
      advanceTimer = null;
      showingResult = false;
      section.classList.remove('is-wizard', 'is-result');
      track.style.transform = '';
      questions.forEach(function (question) {
        if (supportsInert) question.inert = false;
        question.removeAttribute('aria-hidden');
      });
    }

    function sync(event) {
      var matches = event && typeof event.matches === 'boolean' ? event.matches : mql.matches;
      if (matches) enter();
      else exit();
    }

    if (backButton) {
      backButton.addEventListener('click', function () {
        if (advanceTimer) clearTimeout(advanceTimer);
        advanceTimer = null;
        if (showingResult) goToStep(total - 1);
        else if (step > 0) goToStep(step - 1);
      });
    }

    if (mql.addEventListener) mql.addEventListener('change', sync);
    else if (mql.addListener) mql.addListener(sync);
    sync(mql);

    return {
      onAnswered: function (question) {
        if (!section.classList.contains('is-wizard')) return;
        var index = questions.indexOf(question);
        if (index === -1) return;
        if (advanceTimer) clearTimeout(advanceTimer);
        advanceTimer = setTimeout(function () {
          advanceTimer = null;
          if (index >= total - 1) showResult();
          else goToStep(index + 1);
        }, 220);
      }
    };
  }

  function normaliseConfig(config) {
    if (Array.isArray(config.models)) {
      config.models = config.models.map(function (item) {
        if (!item || item.fitDataReady || !item.legacySeriesKey) return item;

        var legacyDefaults = {
          just_walk: {
            supportsWork: true,
            supportsJog: false,
            supportsRun: false,
            storage: 'flat_fold',
            handrail: false,
            maxSpeed: 6
          },
          hybrid: {
            supportsWork: true,
            supportsJog: true,
            supportsRun: true,
            storage: 'flat_fold',
            handrail: true,
            maxSpeed: 12
          },
          foldable_classic: {
            supportsWork: false,
            supportsJog: true,
            supportsRun: true,
            storage: 'compact_fold',
            handrail: true,
            maxSpeed: 12
          },
          vertical_fold: {
            supportsWork: false,
            supportsJog: true,
            supportsRun: true,
            storage: 'upright_fold',
            handrail: true,
            maxSpeed: 18
          }
        };

        return Object.assign({}, item, legacyDefaults[item.legacySeriesKey] || {});
      });
      return config;
    }

    var legacy = Array.isArray(config.series) ? config.series : [];
    return {
      defaultModel: config.defaultSeries || '',
      compareUrl: '',
      models: legacy.map(function (item) {
        return Object.assign({
          seriesName: item.name || '',
          badge: 'Recommended model',
          reason: '',
          available: true,
          supportsWork: item.key === 'just_walk' || item.key === 'hybrid',
          supportsJog: item.key === 'hybrid' || item.key === 'foldable_classic' || item.key === 'vertical_fold',
          supportsRun: item.key === 'foldable_classic' || item.key === 'vertical_fold',
          storage: item.key === 'vertical_fold' ? 'upright_fold' : (item.key === 'foldable_classic' ? 'compact_fold' : 'flat_fold'),
          handrail: item.key !== 'just_walk',
          maxSpeed: item.key === 'vertical_fold' ? 18 : (item.key === 'just_walk' ? 6 : 12),
          specs: []
        }, item);
      })
    };
  }

  function initSection(section) {
    if (section.getAttribute('data-wp-initialised') === 'true') return;
    section.setAttribute('data-wp-initialised', 'true');

    var dataScript = section.querySelector('[data-wp-series-data]');
    var config = { defaultModel: '', compareUrl: '', models: [] };

    if (dataScript) {
      try {
        config = normaliseConfig(JSON.parse(dataScript.textContent));
      } catch (error) {
        config = { defaultModel: '', compareUrl: '', models: [] };
      }
    }

    var models = (config.models || []).filter(function (model) {
      return model && model.key;
    });
    if (!models.length) return;

    var defaultFromBlock = models.find(function (model) { return model.isDefault; });
    var fallbackKey = (defaultFromBlock && defaultFromBlock.key) || config.defaultModel || models[0].key;
    var wizard = setupWizard(section);

    function refresh() {
      var answers = selectedAnswers(section);
      var answeredCount = Object.keys(answers).length;
      var ranked = rankModels(models, answers, fallbackKey);

      if (!answeredCount) {
        var fallbackIndex = ranked.findIndex(function (result) {
          return result.model.key === fallbackKey;
        });
        if (fallbackIndex > 0) {
          var fallback = ranked.splice(fallbackIndex, 1)[0];
          ranked.unshift(fallback);
        }
      }

      updatePrimary(section, ranked[0], answeredCount, config.compareUrl);
      updateAlternatives(section, ranked, answeredCount);
    }

    refresh();

    section.querySelectorAll('.wp-selector-option').forEach(function (button) {
      button.addEventListener('click', function () {
        var question = button.closest('[data-question]');
        if (!question) return;

        question.querySelectorAll('.wp-selector-option').forEach(function (option) {
          option.classList.remove('is-selected');
          option.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');

        var answers = selectedAnswers(section);
        window.dispatchEvent(
          new CustomEvent('wp-series-selector:answer', {
            detail: {
              sectionId: section.getAttribute('data-section-id'),
              question: question.getAttribute('data-question') || '',
              answer: button.getAttribute('data-answer') || '',
              answers: answers
            }
          })
        );

        refresh();
        wizard.onAnswered(question);
      });
    });

    section.querySelectorAll('[data-cta-type]').forEach(function (link) {
      link.addEventListener('click', function () {
        window.dispatchEvent(
          new CustomEvent('wp-series-selector:cta-click', {
            detail: {
              sectionId: section.getAttribute('data-section-id'),
              ctaType: link.getAttribute('data-cta-type') || '',
              modelKey:
                link.getAttribute('data-model-key') ||
                (section.querySelector('[data-result-model]') && section.querySelector('[data-result-model]').getAttribute('data-result-model')) ||
                '',
              href: link.href
            }
          })
        );
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-wp-series-selector]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-wp-series-selector]')
      : null;
    if (section) initSection(section);
  });
})();
